import { createFileRoute } from '@tanstack/react-router'
import { CustomerGroupDetailPage, CUSTOMER_TABS, type CustomerTab } from '@/pages/customer-group-detail'

export const Route = createFileRoute('/_authenticated/customers/$groupId')({
  staticData: { title: 'Customer' },
  component: CustomerGroupDetailRoute,
  // The open tab, so a conversation's way back lands on Comms (USA-1695).
  validateSearch: (search: Record<string, unknown>): { tab?: CustomerTab } => ({
    tab: CUSTOMER_TABS.includes(search.tab as CustomerTab) ? (search.tab as CustomerTab) : undefined,
  }),
})

function CustomerGroupDetailRoute() {
  const { groupId } = Route.useParams()
  const { tab } = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <CustomerGroupDetailPage
      groupId={groupId}
      tab={tab ?? 'overview'}
      onTabChange={(next) =>
        void navigate({ search: { tab: next === 'overview' ? undefined : next }, replace: true })
      }
    />
  )
}
